import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { WorkOrderHistoryPageContext } from "@sonic/Pages/WorkOrderHistoryPage";
import SearchTextField, { SearchTextFieldStyles } from "@sonic/Widgets/WorkOrderHistory/WorkOrderSearchTextField";
import * as React from "react";

export const poNumberStyles: SearchTextFieldStyles = {};
const styles = poNumberStyles;

const OrderHistorySearchPoNumber: React.FunctionComponent<WidgetProps> = () => {
    return <SearchTextField styles={styles} parameterField="poNumber" label="PO #" inputType="text" placeholder="" />;
};

const widgetModule: WidgetModule = {
    component: OrderHistorySearchPoNumber,
    definition: {
        group: "Order History",
        displayName: "Work Order PO Number",
        allowedContexts: [WorkOrderHistoryPageContext],
    },
};

export default widgetModule;
